/* Magic+ membership page (sections/magic-plus.liquid).
   Everything here is decoration on top of a page that already reads fine
   without it: the HTML prints every number, and the reveal classes only hide
   things once this script has added .mplus--js. Reduced motion skips the
   movement but keeps the calculator. */
(function () {
  var root = document.querySelector('[data-mplus]');
  if (!root) return;

  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var rate = parseFloat(root.getAttribute('data-rate')) || 0;
  var base = parseFloat(root.getAttribute('data-base')) || rate;
  var promo = root.hasAttribute('data-promo');

  function money(n) {
    var whole = Math.abs(n - Math.round(n)) < 0.005;
    return '$' + (whole ? Math.round(n).toLocaleString('en-US') : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }
  // credit is floored to the cent, as tms-backend/cashback.py pays it
  function credit(amount, pct) { return Math.floor(amount * pct) / 100; }

  /* ---------- rolling numbers ---------- */
  var rolls = new WeakMap();
  function roll(el, to, fmt) {
    if (!el) return;
    var from = rolls.has(el) ? rolls.get(el) : to;
    rolls.set(el, to);
    if (still || from === to) { el.textContent = fmt(to); return; }
    var start = null, dur = 420;
    if (el._raf) cancelAnimationFrame(el._raf);
    function step(t) {
      if (start === null) start = t;
      var p = Math.min(1, (t - start) / dur);
      var k = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(from + (to - from) * k);
      if (p < 1) el._raf = requestAnimationFrame(step);
      else el.textContent = fmt(to);
    }
    el._raf = requestAnimationFrame(step);
  }

  /* ---------- calculator ---------- */
  var range = root.querySelector('[data-mplus-range]');
  var orders = root.querySelector('[data-mplus-range-orders]');
  var spendOut = root.querySelector('[data-mplus-spend]');
  var ordersOut = root.querySelector('[data-mplus-orders]');
  var ordersWord = root.querySelector('[data-mplus-orders-word]');
  var earnOut = root.querySelector('[data-mplus-earn]');
  var yearOut = root.querySelector('[data-mplus-year]');
  var chips = root.querySelectorAll('[data-mplus-chip]');

  function fill(input) {
    var min = parseFloat(input.min), max = parseFloat(input.max);
    input.style.setProperty('--fill', ((parseFloat(input.value) - min) / (max - min) * 100) + '%');
  }


  function paint() {
    if (!range) return;
    var v = parseFloat(range.value);
    var n = orders ? parseInt(orders.value, 10) : 12;
    var now = credit(v, rate);
    var yearly = credit(v, promo ? base : rate) * n;
    roll(spendOut, v, money);
    if (ordersOut) ordersOut.textContent = n;
    if (ordersWord) ordersWord.textContent = n === 1 ? 'order' : 'orders';
    roll(earnOut, now, money);
    roll(yearOut, yearly, money);
    fill(range);
    if (orders) fill(orders);
    for (var i = 0; i < chips.length; i++) {
      chips[i].setAttribute('aria-pressed', String(parseFloat(chips[i].getAttribute('data-mplus-chip')) === v));
    }
  }

  if (range) {
    range.addEventListener('input', paint);
    if (orders) orders.addEventListener('input', paint);
    for (var c = 0; c < chips.length; c++) {
      chips[c].addEventListener('click', function () {
        range.value = this.getAttribute('data-mplus-chip');
        paint();
      });
    }
    paint();
  }

  if (still) return;

  /* ---------- scroll reveals, count-ups, steps ---------- */
  root.classList.add('mplus--js');

  function countUp(el) {
    var to = parseFloat(el.getAttribute('data-count'));
    if (isNaN(to)) return;
    var dec = String(to).indexOf('.') > -1 ? 1 : 0;
    var start = null, dur = 900;
    el.textContent = '0';
    function step(t) {
      if (start === null) start = t;
      var p = Math.min(1, (t - start) / dur);
      var k = 1 - Math.pow(1 - p, 3);
      el.textContent = (to * k).toFixed(dec);
      if (p < 1) requestAnimationFrame(step); else el.textContent = String(to);
    }
    requestAnimationFrame(step);
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        e.target.querySelectorAll('[data-count]').forEach(countUp);
        io.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    root.querySelectorAll('[data-reveal]').forEach(function (el) { io.observe(el); });

    // steps light up one by one as each reaches the middle of the screen
    var stepIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-on'); stepIo.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -40% 0px' });
    root.querySelectorAll('[data-mplus-steps] > li').forEach(function (li) { stepIo.observe(li); });
  } else {
    root.querySelectorAll('[data-reveal], [data-mplus-steps] > li').forEach(function (el) { el.classList.add('is-in', 'is-on'); });
  }

  /* ---------- hero card: tilt toward the pointer, drift on scroll ---------- */
  var tilt = root.querySelector('[data-mplus-tilt]');
  if (tilt) {
    var img = tilt.firstElementChild;
    var hover = window.matchMedia('(hover: hover)').matches;
    var rx = 0, ry = 0, sy = 0, queued = false;
    function apply() {
      queued = false;
      tilt.style.transform = 'perspective(900px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) translateY(' + sy + 'px)';
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(apply); } }
    if (hover) {
      var hero = tilt.closest('.mplus__hero') || tilt;
      hero.addEventListener('pointermove', function (e) {
        var r = tilt.getBoundingClientRect();
        var x = (e.clientX - (r.left + r.width / 2)) / r.width;
        var y = (e.clientY - (r.top + r.height / 2)) / r.height;
        ry = Math.max(-1, Math.min(1, x)) * 12;
        rx = Math.max(-1, Math.min(1, y)) * -10;
        queue();
      });
      hero.addEventListener('pointerleave', function () { rx = 0; ry = 0; queue(); });
    }
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 900) return;
      sy = y * 0.12;
      if (img) img.style.opacity = String(Math.max(0.35, 1 - y / 1100));
      queue();
    }, { passive: true });
  }

  /* ---------- hero card: press anywhere and that spot is pushed back,
     then it springs back with a bounce (Rich 10-03). A small spring
     simulation, so a quick tap and a long press both feel physical. ---------- */
  var card = root.querySelector('.mpcard');
  var face = card && card.querySelector('.mpcard__face');
  if (card && face) {
    var MAX = 16;       // degrees the pressed corner tips back
    var DEPTH = -34;    // px the whole card sinks
    var K = 260, DAMP = 11;   // spring stiffness and damping: low damping = more bounce
    var st = { rx: 0, ry: 0, z: 0 }, vel = { rx: 0, ry: 0, z: 0 }, goal = { rx: 0, ry: 0, z: 0 };
    var running = false, last = 0, pressed = false;

    function render() {
      face.style.transform = 'translateZ(' + st.z.toFixed(2) + 'px) rotateX(' + st.rx.toFixed(2) + 'deg) rotateY(' + st.ry.toFixed(2) + 'deg)';
    }
    function tick(t) {
      var dt = Math.min(0.032, (t - last) / 1000 || 0.016);
      last = t;
      var moving = false;
      ['rx', 'ry', 'z'].forEach(function (k) {
        var a = -K * (st[k] - goal[k]) - DAMP * vel[k];
        vel[k] += a * dt;
        st[k] += vel[k] * dt;
        if (Math.abs(vel[k]) > 0.01 || Math.abs(st[k] - goal[k]) > 0.01) moving = true;
      });
      render();
      if (moving || pressed) requestAnimationFrame(tick);
      else { running = false; st = { rx: goal.rx, ry: goal.ry, z: goal.z }; render(); }
    }
    function go() {
      if (running) return;
      running = true; last = performance.now();
      requestAnimationFrame(tick);
    }
    function press(e) {
      var r = face.getBoundingClientRect();
      // -1..1 from the centre; top-right is x 1, y -1
      var x = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width) * 2 - 1));
      var y = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height) * 2 - 1));
      pressed = true;
      goal.ry = x * MAX;          // right side pressed -> right side goes back
      goal.rx = -y * MAX;         // top pressed -> top goes back
      goal.z = DEPTH;
      face.style.setProperty('--px', ((x + 1) * 50) + '%');
      face.style.setProperty('--py', ((y + 1) * 50) + '%');
      card.classList.add('is-pressed');
      go();
    }
    function release() {
      if (!pressed) return;
      pressed = false;
      goal.rx = 0; goal.ry = 0; goal.z = 0;
      card.classList.remove('is-pressed');
      go();
    }
    card.addEventListener('pointerdown', function (e) {
      if (e.button && e.button !== 0) return;
      try { card.setPointerCapture(e.pointerId); } catch (err) {}
      press(e);
    });
    card.addEventListener('pointerup', release);
    card.addEventListener('pointercancel', release);
    card.addEventListener('lostpointercapture', release);
    // keyboard: Enter or Space presses the middle
    card.setAttribute('tabindex', '0');
    card.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      var r = face.getBoundingClientRect();
      press({ clientX: r.left + r.width / 2, clientY: r.top + r.height / 2 });
      setTimeout(release, 140);
    });
  }

  /* ---------- questions open and close smoothly ---------- */
  root.querySelectorAll('.mplus__faq details').forEach(function (d) {
    var sum = d.querySelector('summary');
    var body = d.querySelector('p');
    if (!sum || !body || !body.animate) return;
    sum.addEventListener('click', function (e) {
      e.preventDefault();
      if (d.open) {
        var h = body.offsetHeight;
        var a = body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 220, easing: 'ease-in' });
        a.onfinish = function () { d.open = false; };
      } else {
        d.open = true;
        var h2 = body.offsetHeight;
        body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 280, easing: 'cubic-bezier(.2,.7,.2,1)' });
      }
    });
  });
})();
